import { useQuery } from 'react-query';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { getOfficeHoursExceptionsForMultipleLocations } from './api';
import { queryKeys } from './query-keys';
import { GetOfficeHoursExceptionsForMultipleLocationsType } from './types';

export const useGetOfficeExceptionsQuery = (
  req: GetOfficeHoursExceptionsForMultipleLocationsType['input'],
  enabled = true
) => {
  return useQuery({
    queryKey: queryKeys.officeExceptions(req),
    queryFn: () =>
      getOfficeHoursExceptionsForMultipleLocations(req).catch((err) => {
        if (err.message.includes('Maximum number of location IDs allowed')) {
          console.error('Error fetching appointment exceptions', err);
          return { data: [] };
        } else {
          throw err;
        }
      }),
    enabled: !!req.locationIds?.length && enabled,
    onSettled: () =>
      SchedulerV3.trackScheduleAPIVersionChange('v2', { endpoint: 'getOfficeHoursExceptionsForMultipleLocations' }),
  });
};
